<template>
  <base-material-card
    color="primary"
    icon="mdi-note-text"
    :title="titulocard"
    :app-online="appOnline"
  >
    <v-card>
      <v-card-subtitle>
        Os dados registrados <strong>CPF</strong> e <strong>Telefone</strong>, não estão vinculados a nenhum laticínio parceiro.
      </v-card-subtitle>
      <v-card-subtitle
        v-if="false"
        class="my-2"
      >
        Se você tem interesse em utilizar nossa ferramenta, cadastre abaixo os dados do seu Laticínio parceiro que entraremos em contato para fazermos uma proposta de parceria.
      </v-card-subtitle>
    </v-card>

    <validation-observer
      v-if="false"
      v-slot="{ invalid }"
    >
      <form @submit.prevent="onSubmit">
        <v-row>
          <v-col
            cols="12"
          >
            <tex-field-with-validation
              v-model="form.nome"
              rules="required|min:5"
              label="Nome do Laticínio..."
              prepend-icon="mdi-face-outline"
            />

            <tex-field-with-validation
              v-model="form.email"
              rules="email"
              label="Email do Laticínio..."
              prepend-icon="mdi-email-outline"
            />

            <tex-field-with-validation
              v-model="form.cnpj"
              v-mask="maskcnpj"
              label="CNPJ do Laticínio..."
              prepend-icon="mdi-account-box-outline"
            />

            <tex-field-with-validation
              v-model="form.telefone"
              v-mask="maskphone"
              rules="required"
              label="Telefone do Laticínio..."
              prepend-icon="mdi-phone-outline"
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col
            cols="8"
            lg="3"
          >
            <v-btn
              class="v-btn--block"
              :disabled="invalid"
              color="success"
              default
              min-width="180"
              type="submit"
            >
              Enviar
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
  </base-material-card>
</template>

<script>
  export default {
    props: {
      titulocard: {
        type: String,
        default: '',
      },
    },

    data: () => ({
      appOnline: navigator.onLine,
      maskcnpj: '##.###.###/####-##',
      maskphone: '(##)#####-####',
      form: {
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        observacao: '',
      },
    }),

    methods: {
      onSubmit () {
        console.log('Formulario enviado!')
      },
    },
  }
</script>

<style>

</style>
